const { DateTime } = require("luxon");

/**
 * Generate a list of filters to return only neccesary entities
 */
module.exports = function generateJsonApiFilters({
	config,
	constraints,
	list_data,
	sticky = false,
	limit = 0,
	paged,
}) {
	const nowStr = DateTime.now().toUTC().toISO();

	let filters = [
		`filter[sticky][condition][path]=sticky`,
		`filter[sticky][condition][operator]=%3D`,
		`filter[sticky][condition][value]=${sticky ? 1 : 0}`,
	];

	if (constraints) {
		if (constraints.by_rel) {
			for (const [bundle_name, ids] of Object.entries(constraints.by_rel)) {
				filters = [
					...filters,
					`filter[${bundle_name}][condition][path]=field_${bundle_name}.id`,
					`filter[${bundle_name}][condition][operator]=IN`,
				];
				for (const id_index in ids) {
					filters.push(
						`filter[${bundle_name}][condition][value][${
							parseInt(id_index) + 1
						}]=${ids[id_index]}`
					);
				}
			}
		}
	}

	if (limit) {
		filters = [...filters, `page[limit]=${limit}`];
		if (paged) {
			filters = [...filters, `page[offset]=${(paged - 1) * limit}`];
		}
	}

	if (list_data.field_entities_list_sort_by) {
		let sort_path_arr =
			config &&
			config.sortBy &&
			config.sortBy[list_data.field_entities_list_sort_by]
				? config.sortBy[list_data.field_entities_list_sort_by]
				: [];
		let sort_path = sort_path_arr.length > 0 ? sort_path_arr[0] : null;
		if (!sort_path) {
			sort_path =
				list_data.field_entities_list_sort_by === "alphabetically"
					? "title"
					: list_data.field_entities_list_sort_by;
		}
		filters = [...filters, `sort[sorting][path]=${sort_path}`];
	}

	if (list_data.field_entities_list_sort_order) {
		filters = [
			...filters,
			`sort[sorting][direction]=${list_data.field_entities_list_sort_order}`,
		];
	}

	if (list_data.field_promoted) {
		filters = [
			...filters,
			`filter[promoted][condition][path]=promote`,
			`filter[promoted][condition][operator]=%3D`,
			`filter[promoted][condition][value]=${
				list_data.field_promoted === "promoted" ? 1 : 0
			}`,
		];
	}
	if (config.mayRestrict || config.maySchedule) {
		filters = [...filters, `filter[or-group][group][conjunction]=OR`];
		if (config.mayRestrict) {
			filters = [
				...filters,
				`filter[nonrestrict][condition][path]=field_restrict`,
				`filter[nonrestrict][condition][operator]=%3D`,
				`filter[nonrestrict][condition][value]=0`,
			];
		}
		if (config.maySchedule) {
			filters = [
				...filters,
				`filter[nonrestrict][condition][memberOf]=or-group`,
				`filter[datefilter][condition][path]=field_scheduled`,
				`filter[datefilter][condition][operator]=<`,
				`filter[datefilter][condition][value]=${nowStr}`,
				`filter[datefilter][condition][memberOf]=or-group`,
			];
		}
	}
	return filters;
};
